export const SIGN_UP = "/sign-up";
export const SIGN_IN = "/sign-in";

export const HOME = "/";
export const POSTS = "/posts";
export const POST = "/posts/:id";
export const SEARCH = "/posts/search";
export const CREATE = "/posts/create";
export const UPDATE = "/posts/update";

export const USER = "/users/:id";
export const ME = "/users/me";
export const UPDATE_PROFILE = "/users/update";
